import { Grid } from "@mui/material";
import { CommentButton, FavoriteButton, LikeButton } from "views/knowledge/components/card/behaviors/common/Interaction";

///
export const FooterDialog = () => {
    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid>
                        <LikeButton />
                    </Grid>
                    <Grid>
                        <CommentButton />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <FavoriteButton />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
